const theme = {
  // Brand-aligned color palette
  color: [
    "#74d6b3", // brand teal
    "#3b82f6", // blue
    "#f59e0b", // amber
    "#ef4444", // red
    "#8b5cf6", // purple
    "#06b6d4", // cyan
    "#f97316", // orange
    "#10b981", // emerald
    "#6366f1", // indigo
    "#ec4899", // pink
    "#84cc16", // lime
    "#14b8a6", // teal-alt
    "#f43f5e", // rose
    "#a855f7", // violet
    "#0ea5e9", // sky
    "#d946ef", // fuchsia
    "#22c55e", // green
    "#eab308", // yellow
    "#64748b", // slate
    "#78716c"  // stone
  ],

  title: {
    textStyle: {
      fontWeight: "600",
      fontSize: 14,
      color: "#1a1f36"
    }
  },

  dataRange: {
    itemWidth: 15,
    color: ["#74d6b3", "#e8f8f3"]
  },

  toolbox: {
    color: ["#9ca3af", "#9ca3af", "#9ca3af", "#9ca3af"],
    effectiveColor: "#74d6b3"
  },

  tooltip: {
    backgroundColor: "#ffffff",
    borderColor: "#e4e7ec",
    borderWidth: 1,
    padding: [10, 14],
    extraCssText: "box-shadow: 0 4px 12px rgba(0,0,0,0.08); border-radius: 8px;",
    textStyle: {
      color: "#1a1f36",
      fontSize: 13
    },
    axisPointer: {
      type: "line",
      lineStyle: {
        color: "#e4e7ec",
        width: 1,
        type: "dashed"
      },
      crossStyle: {
        color: "#74d6b3"
      },
      shadowStyle: {
        color: "rgba(116, 214, 179, 0.06)"
      }
    }
  },

  dataZoom: {
    dataBackgroundColor: "#f3f4f6",
    fillerColor: "rgba(116, 214, 179, 0.15)",
    handleColor: "#74d6b3"
  },

  grid: {
    borderColor: "#f3f4f6"
  },

  // Category axis (X axis)
  categoryAxis: {
    axisLine: {
      lineStyle: {
        color: "#e4e7ec"
      }
    },
    axisTick: {
      show: false
    },
    axisLabel: {
      color: "#6b7280",
      fontSize: 12
    },
    splitLine: {
      show: false
    }
  },

  // Value axis (Y axis)
  valueAxis: {
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    },
    axisLabel: {
      color: "#6b7280",
      fontSize: 12
    },
    splitArea: {
      show: false
    },
    splitLine: {
      lineStyle: {
        color: ["#f3f4f6"],
        type: "dashed"
      }
    }
  },

  polar: {
    axisLine: {
      lineStyle: {
        color: "#e4e7ec"
      }
    },
    splitArea: {
      show: true,
      areaStyle: {
        color: ["rgba(250,250,250,0.2)", "rgba(200,200,200,0.1)"]
      }
    },
    splitLine: {
      lineStyle: {
        color: "#e4e7ec"
      }
    }
  },

  timeline: {
    lineStyle: {
      color: "#74d6b3"
    },
    controlStyle: {
      normal: { color: "#74d6b3" },
      emphasis: { color: "#3db896" }
    },
    symbol: "circle",
    symbolSize: 5
  },

  bar: {
    itemStyle: {
      normal: {
        barBorderRadius: 4
      },
      emphasis: {
        barBorderRadius: 4
      }
    }
  },

  // Line chart defaults
  line: {
    smooth: true,
    symbol: "circle",
    symbolSize: 6,
    lineStyle: {
      width: 2.5
    }
  },

  k: {
    itemStyle: {
      normal: {
        color: "#ef4444",
        color0: "#74d6b3",
        lineStyle: {
          color: "#ef4444",
          color0: "#74d6b3"
        }
      }
    }
  },

  scatter: {
    symbol: "circle",
    symbolSize: 5
  },

  radar: {
    symbol: "circle",
    symbolSize: 4
  },

  map: {
    itemStyle: {
      normal: {
        areaStyle: { color: "#e8f8f3" },
        label: { textStyle: { color: "#1a1f36" } }
      },
      emphasis: {
        areaStyle: { color: "#74d6b3" }
      }
    }
  },

  gauge: {
    axisLine: {
      lineStyle: {
        color: [
          [0.2, "#74d6b3"],
          [0.8, "#3b82f6"],
          [1, "#ef4444"]
        ],
        width: 10
      }
    },
    axisTick: {
      splitNumber: 10,
      length: 15,
      lineStyle: { color: "auto" }
    },
    splitLine: {
      length: 22,
      lineStyle: { color: "auto" }
    },
    pointer: { width: 5 }
  },

  textStyle: {
    fontFamily: "'Poppins', 'Helvetica Neue', Arial, sans-serif"
  }
};

export default theme;

// 暗色版本：系列配色不变，只把标题/图例/坐标轴/网格/提示框换成暗色令牌的值
// （ECharts 在 canvas 里绘制，读不到 CSS 变量，所以这里写死令牌对应的色值）
const DARK = { heading: "#f2f6fa", ink: "#dbe4ee", ink2: "#94a9bd", line: "#23405c", line2: "#2c4a68", surface2: "#172d44" };

export const darkTheme = {
  ...theme,
  title: { textStyle: { ...theme.title.textStyle, color: DARK.heading } },
  legend: { textStyle: { color: DARK.ink2 } },
  tooltip: {
    ...theme.tooltip,
    backgroundColor: DARK.surface2,
    borderColor: DARK.line,
    extraCssText: "box-shadow: 0 4px 12px rgba(0,0,0,0.4); border-radius: 8px;",
    textStyle: { ...theme.tooltip.textStyle, color: DARK.ink },
    axisPointer: { ...theme.tooltip.axisPointer, lineStyle: { ...theme.tooltip.axisPointer.lineStyle, color: DARK.line2 } }
  },
  dataZoom: { ...theme.dataZoom, dataBackgroundColor: DARK.line, textStyle: { color: DARK.ink2 } },
  grid: { borderColor: DARK.line },
  categoryAxis: {
    ...theme.categoryAxis,
    axisLine: { lineStyle: { color: DARK.line2 } },
    axisLabel: { ...theme.categoryAxis.axisLabel, color: DARK.ink2 },
    nameTextStyle: { color: DARK.ink2 }
  },
  valueAxis: {
    ...theme.valueAxis,
    axisLabel: { ...theme.valueAxis.axisLabel, color: DARK.ink2 },
    splitLine: { lineStyle: { ...theme.valueAxis.splitLine.lineStyle, color: [DARK.line] } },
    nameTextStyle: { color: DARK.ink2 }
  },
  textStyle: { ...theme.textStyle, color: DARK.ink }
};

// 按当前 <html data-theme> 选主题名；图表在 init 时定型，切换主题后需重新进入页面
export const chartThemeName = () =>
  document.documentElement.getAttribute("data-theme") === "dark" ? "macarons-dark" : "macarons";
